import React from "react";
import PropTypes from "prop-types";
import subscribe from "venuescanner-js/react/helpers/subscribe";
import SrpContainer from "../../containers/SrpContainer";
import RadiusField from "venuescanner-js/react/components/SelectField/RadiusField";
import classes from "./styles.module.scss";

export const SrpNavRadiusField = ({ srpContainer }) => {
  const { query } = srpContainer.state;

  const queryRadius = 1 * (query.radius || 0);

  return (
    <RadiusField
      value={queryRadius}
      placeholder={"+ mi"}
      containerClassName={classes.SrpNavFieldContainer}
      onChange={(val) => {
        srpContainer.patchQuery({
          radius: val && val.value,
        });
        if (srpContainer.hasValidLocation)
          srpContainer.refresh({ refresh: true });
      }}
    />
  );
};

SrpNavRadiusField.propTypes = {
  srpContainer: PropTypes.instanceOf(SrpContainer).isRequired,
};

export default subscribe({ SrpContainer })(SrpNavRadiusField);
